/**
* supervision detail management
*/
//import { parseMark } from '../../app'

module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
    	.state('member.assessments.detail.notation', {
            url: urls.member.assessments.notation.fr,
            views: {
                assessmentTitle: {
                    controller: ['$scope', '$filter', '$state', function ($scope, $filter, $state) {
                        $scope.title = $filter('translate')('assessments.titleSatisfaction');
                        $scope.back = {
                            label: $filter('translate')('assessments.back'),
                            state: $state.href('member.assessments.list')
                        };
                    }],
                    templateUrl: 'src/views/member/assessments/member_supervision_title.html'
                },
                assessmentContent: {
                    controller: ['$q', '$scope', '$rootScope', '$filter', 'drupal', 'moment', '$state', '$stateParams', 'tools', function ($q, $scope, $rootScope, $filter, $drupal, moment, $state, $stateParams, tools) {
                        var internshipId = $stateParams.id;
                        $scope.loading = true;
                        $scope.evaluation = {};
                        $scope.tools = tools;

                        $drupal.getFeedback(internshipId).then(function (notation) {
                            var hasFeedback = false;
                            var notes = Object.keys(notation.retour).map(function (k) {
                                if (notation.retour[k] !== null) {
                                    hasFeedback = true;
                                }
                                return { label: k, value: notation.retour[k]};
                            });

                            angular.merge($scope.evaluation, {
                                global: tools.parseMark(notation.global),
                                hasFeedback: hasFeedback,
                                notes: notes
                            });
                        }).finally(function () {
                            $scope.loading = false;
                        });
                    }],
                    templateUrl: 'src/views/member/assessments/member_assessments_notation.html'
                }
            }
        });
    }]);